<template>
  <div>
    <BannerCarousel />
    <!-- 赢家专区/abi(冰柜，资产物料) 关键字搜索 -->
    <div class="content-wrapper">
      <div v-loading="listLoading" class="list-container">
        <div v-if="itemList.length">
          <div v-for="item in itemList" :key="item.itemId" class="item-box" @click="buyAsset(item)">
            <img :src="getImageUrl(item)">
          </div>
          <div class="item-pagination">
            <el-pagination
              :current-page="queryParam.page"
              :page-size="queryParam.pageSize"
              :total="total"
              layout="total, prev, pager, next, jumper"
              @current-change="handleCurrentChange"/>
          </div>
        </div>
        <div v-else class="no-data">
          当前没有商品信息
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import itemApi from '@/api/item'
import { commonUtils } from '@/utils/common'
import BannerCarousel from '@/views/components/banner-carousel'
export default {
  name: 'ItemListNormal',
  components: {
    BannerCarousel
  },
  data() {
    return {
      queryParam: {
        page: 1,
        pageSize: 12,
        abiBrandId: '',
        keyword: ''
      },
      total: null,
      listLoading: false,
      itemList: [],
      defaultImage: require('../../assets/images/image-not-found.png'),
      userInfo: {}
    }
  },
  computed: {
    ...mapGetters([
      'winPlusRole'
    ])
  },
  mounted() {
    this.init()
    this.userInfo = Object.assign({}, this.userInfo, this.$store.getters.userInfo)
  },
  beforeRouteUpdate (to, from, next) {
    this.setKeyword(to.query.keyword).then(() => {
      return this.setAbiBrandId(to.query.abiBrandId)
    }).then(() => {
      if (this.winPlusRole === 'material') {
        this.queryPocmList()
      } else {
        this.queryItemList()
      }
    })
    next()
  },
  methods: {
    init() {
      const keyword = this.$route.query.keyword
      const abiBrandId = this.$route.query.abiBrandId
      this.setKeyword(keyword).then(() => {
        return this.setAbiBrandId(abiBrandId)
      }).then(() => {
        if (this.winPlusRole === 'material') {
          this.queryPocmList()
        } else {
          this.queryItemList()
        }
      })
    },
    queryItemList() {
      this.listLoading = true
      itemApi.queryItemList(this.queryParam).then(response => {
        this.listLoading = false
        if (response.data.resultCode === '0') {
          this.itemList = response.data.resultData.itemList
          this.total = response.data.resultData.pageInfo.totalCounts
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    queryPocmList() {
      this.listLoading = true
      itemApi.queryPocmList(this.queryParam).then(response => {
        this.listLoading = false
        if (response.data.resultCode === '0') {
          this.itemList = response.data.resultData.itemList
          this.total = response.data.resultData.pageInfo.totalCounts
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    setKeyword(keyword) {
      return new Promise((resolve) => {
        this.queryParam.keyword = keyword ? keyword : null
        resolve()
      })
    },
    setAbiBrandId(abiBrandId) {
      return new Promise((resolve) => {
        this.queryParam.abiBrandId = abiBrandId ? abiBrandId : null
        resolve()
      })
    },
    getImageUrl(item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    },
    handleCurrentChange(val){
      this.queryParam.page = val
      this.queryItemList()
    },
    buyAsset(item) {
      if (this.winPlusRole === 'material') {
        let routeData = this.$router.resolve({ name: 'item-info-pocm', params: { itemId: item.itemId } })
        window.open(routeData.href, '_blank')
        return
      }
      // 不可下单
      if (this.userInfo.canOrder) {
        return
      }
      this.$router.push({ path: '/order/asset/confirm', query: { buyItemId: item.itemId}})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.list-container{
  width: 100%;
  margin: 20px auto;

  .item-box {
    width: 720px;
    margin: 10px auto;
    cursor: pointer;
    text-align: center;
    img {
      max-width: 100%;
    }
  }
}
.item-pagination {
  text-align: right;
  /deep/ .el-pager li.active {
    color: $base-red;
  }
}
</style>
